import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DxLoadPanelModule, DxPopupModule, DxTabsModule } from 'devextreme-angular';
import { FieldsInterventionsMapModule } from '../fields-interventions-map/fields-interventions-map.module';
import { FieldsInterventionsMetricsModule } from '../fields-interventions-metrics/fields-interventions-metrics.module';
import { FieldsInterventionsReportComponent } from './fields-interventions-report.component';

@NgModule({
  declarations: [FieldsInterventionsReportComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxTabsModule,
    DxLoadPanelModule,
    FieldsInterventionsMetricsModule,
    FieldsInterventionsMapModule
  ],
  exports: [FieldsInterventionsReportComponent]
})
export class FieldsInterventionsReportModule { }
